/**
 * Lightweight pub/sub so compliance-affecting mutations can refresh
 * the Compliance page and app-bar badge without shared React context.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

export const subscribeComplianceInvalidate = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Notify all subscribers to reload compliance cards/lists. */
export const invalidateCompliance = (): void => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (err) {
      console.error("compliance invalidate listener failed", err);
    }
  });
};
